import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";
import { ContactForm } from "@/components/ContactForm";
import { Card } from "@/components/ui/card";
import { Mail, MapPin } from "lucide-react";

const Contact = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <ContentPageNav />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="py-10 md:py-24 px-3">
          <div className="container mx-auto max-w-4xl text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
              Contact
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
              Heb je vragen over De Hussel App, wil je meer informatie of heb je
              feedback? Neem gerust contact met ons op.
            </p>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className="py-6 px-3">
          <div className="container mx-auto max-w-2xl">
            <h2 className="text-2xl font-bold text-foreground mb-6 text-center">
              Stuur ons een bericht
            </h2>
            <ContactForm />
          </div>
        </section>

        {/* Contact Info */}
        <section className="py-8 md:py-12 px-3">
          <div className="container mx-auto max-w-4xl">
            <div className="grid md:grid-cols-2 gap-5 md:gap-8">
              <Card className="p-5 md:p-8 bg-card">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-accent/20 rounded-lg">
                    <Mail className="h-6 w-6 text-accent" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-foreground mb-2">
                      E-mail
                    </h3>
                    <p className="text-muted-foreground mb-4">
                      Voor algemene vragen, ondersteuning of samenwerkingen.
                    </p>
                    <a
                      href="mailto:info@dehusselapp.nl"
                      className="text-accent hover:underline font-medium"
                    >
                      info@dehusselapp.nl
                    </a>
                  </div>
                </div>
              </Card>

              <Card className="p-5 md:p-8 bg-card">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-accent/20 rounded-lg">
                    <MapPin className="h-6 w-6 text-accent" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-foreground mb-2">
                      Locatie
                    </h3>
                    <p className="text-muted-foreground">
                      De Hussel App is een initiatief vanuit Nederland, gemaakt
                      voor tennis- en padelclubs door heel het land.
                    </p>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
